import React from 'react';
import { Tabs, Tab } from '@material-ui/core';
import { map, orderBy } from 'lodash/fp';
import { SectionTabsProps } from './types';

const SectionTabs = ({ sections, active, setActive }: SectionTabsProps) => {
    const orderedSections = orderBy('ordering', 'asc', sections);
    const tabs = map(({ name: label, id }) => {
        const handleTabClick = () => setActive(id);
        return (
            <Tab
                key={id}
                value={id}
                label={label}
                onClick={handleTabClick}
            />
        );
    }
    )(orderedSections);

    return (
        <Tabs
            value={active}
            indicatorColor='primary'
            textColor='primary'
            variant='fullWidth'
            centered
        >
            {tabs}
        </Tabs>
    );
};

export default SectionTabs;
